import {
  COMPLEX_FIELD_KEYS,
  FIELD_KEYS,
  MODEL_KEYS,
  buildComplexFieldKey,
} from "@/constants/fieldKeys";
import { FieldSchemaFormBuilderV2, SchemaFactoryV2 } from "@ucl/library";
import {
  EStatementsOptInComplexField,
  ChecksOptInComplexField,
  WiresOptInComplexField,
  AchOptInComplexField,
  PositivePayOptInComplexField,
  RemoteDepositScannerOptInComplexField,
  CdarsOptInComplexField,
  InsuredCashSweepOptInComplexField,
} from "../ComplexFields";
import { DepositApplicationReadDTO } from "@/types";

export const createOptInsFormBuilder = (
  schemaFactory: SchemaFactoryV2
): FieldSchemaFormBuilderV2<DepositApplicationReadDTO> => {
  return (onValueChange, form, errors) => {
    const fields = [
      ...schemaFactory.buildModelSchema<DepositApplicationReadDTO>(
        MODEL_KEYS.DEPOSIT_APPLICATION,
        onValueChange,
        form,
        errors,
        [
          // E-Statements
          // Add any required fields here

          // Checks
          // Add any required fields here

          // Wires
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.WIRES_OPT_IN,
            COMPLEX_FIELD_KEYS.WIRES_OPT_IN.WIRE_TYPE_AS_LIST
          ),
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.WIRES_OPT_IN,
            COMPLEX_FIELD_KEYS.WIRES_OPT_IN.ESTIMATED_QUANTITY_OF_WIRES_PER_MONTH
          ),
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.WIRES_OPT_IN,
            COMPLEX_FIELD_KEYS.WIRES_OPT_IN.AVERAGE_DOLLAR_AMOUNT_PER_WIRE
          ),
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.WIRES_OPT_IN,
            COMPLEX_FIELD_KEYS.WIRES_OPT_IN.ESTIMATED_TOTAL_WIRE_DOLLAR_AMOUNT_PER_MONTH
          ),

          // ACH
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.ACH_OPT_IN,
            COMPLEX_FIELD_KEYS.ACH_OPT_IN.APPLICABLE_SEC_CODES_AS_LIST
          ),
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.ACH_OPT_IN,
            COMPLEX_FIELD_KEYS.ACH_OPT_IN.ACH_PURPOSES_AS_LIST
          ),
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.ACH_OPT_IN,
            COMPLEX_FIELD_KEYS.ACH_OPT_IN.ESTIMATED_QUANTITY_OF_ACH_TRANSACTIONS_PER_MONTH
          ),
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.ACH_OPT_IN,
            COMPLEX_FIELD_KEYS.ACH_OPT_IN.MAXIMUM_DOLLAR_AMOUNT_OF_ACH_TRANSACTIONS_PER_DAY
          ),
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.ACH_OPT_IN,
            COMPLEX_FIELD_KEYS.ACH_OPT_IN.AVERAGE_DOLLAR_AMOUNT_OF_ACH_TRANSACTIONS_PER_DAY
          ),
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.ACH_OPT_IN,
            COMPLEX_FIELD_KEYS.ACH_OPT_IN.TOTAL_ACH_AMOUNT_IN_DOLLARS_PER_MONTH
          ),

          // Positive Pay
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.POSITIVE_PAY_OPT_IN,
            COMPLEX_FIELD_KEYS.POSITIVE_PAY_OPT_IN.DEFAULT_POSITIVE_PAY_DECISION
          ),

          // Remote Deposit Scanner
          buildComplexFieldKey(
            FIELD_KEYS.DEPOSIT_APPLICATION.REMOTE_DEPOSIT_SCANNER_OPT_IN,
            COMPLEX_FIELD_KEYS.REMOTE_DEPOSIT_SCANNER_OPT_IN.COMPUTER_TYPE
          ),

          // CDARS
          // Add any required fields here

          // Insured Cash Sweep
          // Add any required fields here
        ],
        {
          EStatementsOptInExpressionSchema: EStatementsOptInComplexField,
          ChecksOptInExpressionSchema: ChecksOptInComplexField,
          WiresOptInExpressionSchema: WiresOptInComplexField,
          AchOptInExpressionSchema: AchOptInComplexField,
          PositivePayOptInExpressionSchema: PositivePayOptInComplexField,
          RemoteDepositScannerOptInExpressionSchema: RemoteDepositScannerOptInComplexField,
          CdarsOptInExpressionSchema: CdarsOptInComplexField,
          InsuredCashSweepOptInExpressionSchema: InsuredCashSweepOptInComplexField,
        }
      ),
    ];

    return fields;
  };
};
